const { getNumber } = require('../utils');
export default [
    {
        title: '序号',
        type: 'number',
        dataIndex: 'id',
        key: 'id',
        width: '10%',
        sorter: (a, b) => a.id - b.id,
        defaultSortOrder: 'ascend',
    },
    {
        title: '机器人',
        type: 'string',
        dataIndex: 'robot',
        key: 'robot',
        width: '10%',
        sorter: (a, b) => getNumber(a.robot) - getNumber(b.robot),

        editable: true,
    },
    {
        title: '启动中',
        type: 'boolean',
        dataIndex: 'start',
        key: 'start',
        width: '10%',
        render: (text) => text ? text.toString() : 'false',
        sorter: (a, b) => Number(b.start) - Number(a.start),
        editable: true,
    },
    {
        title: '演唱会',
        type: 'string',
        dataIndex: 'concert',
        key: 'concert',
        width: '15%',
        sorter: (a, b) => a.concert.localeCompare(b.concert),
        editable: true,
    },
    {
        title: '价格',
        type: 'string',
        dataIndex: 'price',
        key: 'price',
        width: '10%',
        sorter: (a, b) => getNumber(a.price) - getNumber(b.price),
        editable: true,
    },
    {
        title: '随机访问',
        type: 'string',
        dataIndex: 'randomNum',
        key: 'randomNum',
        width: '12%',
        editable: true,
    },
    {
        title: '地址',
        type: 'string',
        dataIndex: 'samHost',
        key: 'samHost',
        width: '15%',
        editable: true,
    }
];